import { useFormik } from "formik";
import { JsonParam, useQueryParam } from "use-query-params";
import Drawer from "../../../common/Drawer";
import Messages from "../../../languages/Messages";
import ProductFilterForm from "./ProductFilterForm";
import { mapProductFilterToQueryParams } from "../../../interfaces/product";

interface IProductFilterDrawer {
    open: boolean;
    onClose: () => void;
}

const ProductFilterDrawer = ({ open, onClose }: IProductFilterDrawer) => {
    const [filter, setFilter] = useQueryParam<any>("filter", JsonParam);

    const filterForm = useFormik<any>({
        initialValues: filter ?? ({} as any),
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values: any) => {
            const params = mapProductFilterToQueryParams(values);
            setFilter(params);
            onClose();
        },
    });

    return (
        <Drawer
            open={open}
            onClose={onClose}
            title={Messages.filter}
            onSave={() => filterForm?.handleSubmit()}
            size="auto"
            width="30%"
        >
            <ProductFilterForm filterForm={filterForm} />
        </Drawer>
    );
};

export default ProductFilterDrawer;
